import Tone from 'tone';

const DEFAULT_NOTE = new Tone.Frequency('C3');

export default superclass => class extends superclass  {
    triggerAttack(transpose, time, velocity, voice) {
        if (!this.enabled) {
            return;
        }
        let note = this.getNoteFromTranspose(transpose);
        
        this.lastNote = transpose;

        voice.triggerAttack(note, time, velocity);
    }

    triggerAttackRelease(transpose , duration, time, velocity, voice) {
        if (!this.enabled) {
            return;
        }
        let note = this.getNoteFromTranspose(transpose);
        voice.triggerAttackRelease(
            note, duration, time, velocity);
    }

    triggerRelease(transposes, voice, time=Tone.Master.context.currentTime, releaseTime) {
        if (!this.enabled) {
            return;
        }
        if (transposes && transposes.map === undefined) {
            transposes = [transposes];
        }

        if (transposes && this.polyphony == 1 && transposes[0] !== this.lastNote) {
            return;
        }

        let notes = transposes && transposes.map(
            transpose =>
                this.getNoteFromTranspose(transpose));

        if (voice !== undefined) {
            this.pitchEnvelope.triggerRelease(voice.slotNumber);
            voice.triggerRelease(time, releaseTime);
        } else if (notes) {
            this.triggerRelease(notes, time);
        }
    }

    getNoteFromTranspose(transpose) {
        return this.getDefaultNote()
            .transpose(transpose + this.oscillatorFrequency);
    }

    getDefaultNote() {
        return DEFAULT_NOTE;
    }

}
